import { render, staticRenderFns } from "./FormInputGroupMultipleAddons.vue?vue&type=template&id=4f08827a&"
import script from "./FormInputGroupMultipleAddons.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupMultipleAddons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports